/*
 * ke-cart.js — myEureka shared AJAX add-to-cart helper.
 *
 * Exposes window.KECart.add(variantId, opts) which:
 *   1. POSTs to /cart/add.js (stays on the page — no redirect)
 *   2. refreshes the header cart-count bubble from /cart.js
 *   3. shows a "チェックアウトはこちら" speech bubble under the header
 *      cart icon (fade in -> hold ~3.5s -> fade out)
 *
 * Used by the flavor collection cards and the gift-box feature section.
 * Depends only on Dawn's standard #cart-icon-bubble / .cart-count-bubble
 * in the header. Returns a Promise so callers can manage their own button
 * state and fall back to a native form submit on failure.
 */
(function () {
  if (window.KECart) return;

  var CART_PATH = '/cart';
  var bubbleEl = null;
  var bubbleTimer = null;
  var reposBound = false;

  function cartIcon() {
    return document.getElementById('cart-icon-bubble');
  }

  /* Reflect the authoritative item count in the header bubble. */
  function refreshCount() {
    return fetch(CART_PATH + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var icon = cartIcon();
        if (!icon) return;
        var bubble = icon.querySelector('.cart-count-bubble');
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span>';
          icon.appendChild(bubble);
        }
        var span = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
        if (span) span.textContent = cart.item_count < 100 ? cart.item_count : '';
      })
      .catch(function () {});
  }

  function ensureBubble() {
    bubbleEl = document.getElementById('ke-cart-pop');
    if (bubbleEl) return bubbleEl;
    bubbleEl = document.createElement('div');
    bubbleEl.id = 'ke-cart-pop';
    bubbleEl.className = 'ke-cart-pop';
    bubbleEl.setAttribute('role', 'status');
    bubbleEl.innerHTML =
      '<a class="ke-cart-pop__link" href="' + CART_PATH + '">' +
      'チェックアウトはこちら' +
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
      '</a>';
    document.body.appendChild(bubbleEl);
    return bubbleEl;
  }

  function positionBubble() {
    var icon = cartIcon();
    if (!icon || !bubbleEl) return;
    var r = icon.getBoundingClientRect();
    bubbleEl.style.top = r.bottom + 10 + 'px';
    bubbleEl.style.right = Math.max(8, window.innerWidth - r.right - 4) + 'px';
  }

  function hideBubble() {
    if (!bubbleEl) return;
    bubbleEl.classList.remove('is-visible');
    if (reposBound) {
      window.removeEventListener('scroll', positionBubble);
      window.removeEventListener('resize', positionBubble);
      reposBound = false;
    }
  }

  function showBubble() {
    ensureBubble();
    positionBubble();
    void bubbleEl.offsetWidth; /* force reflow so the transition re-runs */
    bubbleEl.classList.add('is-visible');
    if (!reposBound) {
      window.addEventListener('scroll', positionBubble, { passive: true });
      window.addEventListener('resize', positionBubble);
      reposBound = true;
    }
    if (bubbleTimer) clearTimeout(bubbleTimer);
    bubbleTimer = setTimeout(hideBubble, 3500);
  }

  window.KECart = {
    /*
     * Add a variant to the cart without leaving the page.
     * Returns a Promise resolving with the /cart/add.js response,
     * or rejecting on network/HTTP error so the caller can fall back.
     */
    add: function (variantId, opts) {
      opts = opts || {};
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: opts.quantity || 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (data) {
          return refreshCount().then(function () {
            showBubble();
            return data;
          });
        });
    }
  };
})();
